import { call, put, takeLatest } from 'redux-saga/effects';
import { useCaseBuilderActions } from '../reducers/usecase-management';
import usecaseManagementServices from '../api/usecaseManagementServices';

function* getUseCaseDataSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(usecaseManagementServices.getUseCaseData, action.payload);
    yield put(useCaseBuilderActions.getUseCaseDataResponse(response));
  } catch (error: any) {
    yield put(useCaseBuilderActions.getUseCaseDataFailed(error?.status));
  }
}

function* addUseCaseSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(usecaseManagementServices.addUseCase, action.payload);
    yield put(useCaseBuilderActions.addUseCaseResponse(response));
  } catch (error: any) {
    yield put(useCaseBuilderActions.addUseCaseFailed(error?.status));
  }
}

function* updateUseCaseSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(usecaseManagementServices.updateUseCase, action.payload.payload);
    yield put(useCaseBuilderActions.updateUseCaseResponse(response));
    yield put(useCaseBuilderActions.getDeployedUsecaseRequest(undefined));
  } catch (error: any) {
    yield put(useCaseBuilderActions.updateUseCaseFailed(error?.status));
  }
}

function* updateUseCaseAccessSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(usecaseManagementServices.updateUseCaseAccess, action.payload.payload);
    yield put(useCaseBuilderActions.updateUseCaseAccessResponse(response));
    yield put(useCaseBuilderActions.getDeployedUsecaseRequest(undefined));
  } catch (error: any) {
    yield put(useCaseBuilderActions.updateUseCaseAccessFailed(error?.status));
  }
}

function* deleteUseCaseSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(usecaseManagementServices.deleteUseCase, action.payload);
    yield put(useCaseBuilderActions.removeUseCaseResponse(response));
    yield put(useCaseBuilderActions.getDeployedUsecaseRequest(undefined));
  } catch (error: any) {
    yield put(useCaseBuilderActions.removeUseCaseFailed(error?.response?.data));
  }
}

function* getCustomJsonTemplatesSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(usecaseManagementServices.getCustomJsonTemplates, action.payload);
    yield put(useCaseBuilderActions.getCustomJsonTemplatesResponse(response));
  } catch (error: any) {
    yield put(useCaseBuilderActions.getCustomJsonTemplatesFailed(error?.status));
  }
}

function* addCustomJsonTemplateSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(usecaseManagementServices.addCustomJsonTemplate, action.payload);
    yield put(useCaseBuilderActions.addCustomJsonTemplateResponse(response));
  } catch (error: any) {
    yield put(useCaseBuilderActions.addCustomJsonTemplateFailed(error?.status));
  }
}

function* updateCustomJsonTemplateSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(usecaseManagementServices.updateCustomJsonTemplate, action.payload);
    yield put(useCaseBuilderActions.updateCustomJsonTemplateResponse(response));
  } catch (error: any) {
    yield put(useCaseBuilderActions.updateCustomJsonTemplateFailed(error?.status));
  }
}

function* deleteCustomJsonTemplateSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(usecaseManagementServices.deleteCustomJsonTemplate, action.payload);
    yield put(useCaseBuilderActions.deleteCustomJsonTemplateResponse(response));
  } catch (error: any) {
    yield put(useCaseBuilderActions.deleteCustomJsonTemplateFailed(error?.response?.data));
  }
}

function* approveUseCaseSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(usecaseManagementServices.approveUseCase, action.payload.payload);
    yield put(useCaseBuilderActions.approveUseCaseResponse(response));
    yield put(useCaseBuilderActions.getDeployedUsecaseRequest(undefined));
  } catch (error: any) {
    yield put(useCaseBuilderActions.approveUseCaseFailed(error?.status));
  }
}

function* getDeployedUsecaseSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(usecaseManagementServices.getDeployedUsecase, action.payload);
    yield put(useCaseBuilderActions.getDeployedUsecaseResponse(response));
  } catch (error: any) {
    yield put(useCaseBuilderActions.getDeployedUsecaseFailed(error?.status));
  }
}

function* setDefaultDashboardSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(usecaseManagementServices.updateDefaultDashboard, action.payload);
    yield put(useCaseBuilderActions.setDefaultDashboardResponse(response));
    yield put(useCaseBuilderActions.getDeployedUsecaseRequest(undefined));
  } catch (error: any) {
    yield put(useCaseBuilderActions.setDefaultDashboardFailed(error?.status));
  }
}

function* getGrafanaTempaltes(action: any): Generator<any, void, any> {
  try {
    const response = yield call(usecaseManagementServices.getCustomJsonTemplates, action.payload);
    yield put(useCaseBuilderActions.getGrafanaTemplatesResponse(response));
  } catch (error: any) {
    yield put(useCaseBuilderActions.getGrafanaTemplatesFailed(error?.status));
  }
}

function* updateUseCaseOntologyFilter(action: any): Generator<any, void, any> {
  try {
    const response = yield call(usecaseManagementServices.updateUseCaseOntologyFilter, action.payload);
    yield put(useCaseBuilderActions.updateUseCaseOntologyFilterResponse(response));
  } catch (error: any) {
    yield put(useCaseBuilderActions.updateUseCaseOntologyFilterFailed(error?.status));
  }
}

export default function* UseCaseBuilderSaga() {
  yield takeLatest(useCaseBuilderActions.getUseCaseDataRequest.type, getUseCaseDataSaga);
  yield takeLatest(useCaseBuilderActions.addUseCaseRequest.type, addUseCaseSaga);
  yield takeLatest(useCaseBuilderActions.updateUseCaseRequest.type, updateUseCaseSaga);
  yield takeLatest(useCaseBuilderActions.removeUseCaseRequest.type, deleteUseCaseSaga);
  yield takeLatest(useCaseBuilderActions.getCustomJsonTemplatesRequest.type, getCustomJsonTemplatesSaga);
  yield takeLatest(useCaseBuilderActions.addCustomJsonTemplateRequest.type, addCustomJsonTemplateSaga);
  yield takeLatest(useCaseBuilderActions.updateCustomJsonTemplateRequest.type, updateCustomJsonTemplateSaga);
  yield takeLatest(useCaseBuilderActions.deleteCustomJsonTemplateRequest.type, deleteCustomJsonTemplateSaga);
  yield takeLatest(useCaseBuilderActions.approveUseCaseRequest.type, approveUseCaseSaga);
  yield takeLatest(useCaseBuilderActions.getDeployedUsecaseRequest.type, getDeployedUsecaseSaga);
  yield takeLatest(useCaseBuilderActions.updateUseCaseAccessRequest.type, updateUseCaseAccessSaga);
  yield takeLatest(useCaseBuilderActions.setDefaultDashboardRequest.type, setDefaultDashboardSaga);
  yield takeLatest(useCaseBuilderActions.getGrafanaTemplatesRequest.type, getGrafanaTempaltes);
  yield takeLatest(useCaseBuilderActions.updateUseCaseOntologyFilterRequest.type, updateUseCaseOntologyFilter);
}